<template>
    <div class="verAddCon"  v-if='showModel' ref='verAddConRef' >
        <div class="mainTitle">
            <span>{{title}}</span>
            <Icon type="md-refresh" style="margin-left:10px" @click="getData" />
        </div>
        <Icon class="colseButton" type="ios-close-circle" size='30' style="color:#ed4014" @click="cancel" />

        <div>
            <div class="side" :style="{left:showLeftPx?'302px':'41px'}">
                 <Menu   :open-names="['1','2','3']" @on-select='chooseMenu' :active-name="activeName">
                    <Submenu name="1">
                        <template slot="title">
                            <Icon type="ios-paper" />
                             {{$t('BasicProduct.funcBox.sideList.topSide1')}}
                        </template>
                        <MenuItem name="1-1">{{$t('BasicProduct.funcBox.sideList.side1')}}</MenuItem>
                        <MenuItem name="1-2">{{$t('BasicProduct.funcBox.sideList.side2')}}</MenuItem>
                        <MenuItem name="1-3">{{$t('BasicProduct.funcBox.sideList.side3')}}</MenuItem>
                        <MenuItem name="1-4">{{$t('BasicProduct.funcBox.sideList.side4')}}</MenuItem>
                        <MenuItem name="1-5">{{$t('BasicProduct.funcBox.sideList.side5')}}</MenuItem>
                        <MenuItem name="1-6">{{$t('BasicProduct.funcBox.sideList.side6')}}</MenuItem>
                        <MenuItem name="1-7">{{$t('BasicProduct.funcBox.sideList.side7')}}</MenuItem>
                    </Submenu>
                    <Submenu name="2">
                        <template slot="title">
                            <Icon type="ios-people" />
                             {{$t('BasicProduct.funcBox.sideList.topSide2')}}
                        </template>
                        <MenuItem name="2-6">{{$t('BasicProduct.funcBox.sideList.side3')}}</MenuItem>
                    </Submenu>

                    <Submenu name="3">
                        <template slot="title">
                            <Icon type="ios-people" />
                             {{$t('BasicProduct.funcBox.sideList.topSide3')}}
                        </template>
                        <MenuItem name="3-8">{{$t('BasicProduct.funcBox.sideList.side8')}}</MenuItem>
                    </Submenu>
                  
                </Menu>
            </div>


            <div class="content" ref="contentRef"  @scroll="scrollChange">
                
                <div id="red" class="scroll-item" style="min-height:300px;background-color:whrite">
                    <h3 style="margin:15px 0;">{{$t('BasicProduct.funcBox.sideList.side1')}}  0x01</h3>
                    <Button type="success" class="addButton" @click="addData(1,1,$t('BasicProduct.funcBox.sideList.side1')+' 0x01')" style="margin-right:8px;">{{$t("BasicProduct.funcBox.add")}}</Button>

                    <TableTemp dataUrl="" :dataObj="resData" :dataParams="{keyType:1,communicateProtocol:editFormData.communicateProtocol}" :funType="$t('BasicProduct.funcBox.sideList.side1')+' 0x01'" @addData="setData" @todelData="todelData"></TableTemp>
                </div>
                <div id="green" class="scroll-item" style="min-height:300px;background-color:whrite">
                    <h3 style="margin:15px 0;">{{$t('BasicProduct.funcBox.sideList.side2')}}  0x02</h3>
                    <Button type="success" class="addButton" @click="addData(1,2,$t('BasicProduct.funcBox.sideList.side2')+' 0x02')" style="margin-right:8px;">{{$t("BasicProduct.funcBox.add")}}</Button>

                    <TableTemp dataUrl="" :dataObj="resData" :dataParams="{keyType:2,communicateProtocol:editFormData.communicateProtocol}" :funType="$t('BasicProduct.funcBox.sideList.side2')+' 0x02'" @addData="setData" @todelData="todelData"></TableTemp>
                </div>
                <div id="blue" class="scroll-item" style="min-height:300px;background-color:whrite">
                    <h3 style="margin:15px 0;">{{$t('BasicProduct.funcBox.sideList.side3')}}  0x03</h3>
                    <Button type="success" class="addButton" @click="addData(1,3,$t('BasicProduct.funcBox.sideList.side3')+' 0x03')" style="margin-right:8px;">{{$t("BasicProduct.funcBox.add")}}</Button>

                    <TableTemp dataUrl="" :dataObj="resData" :dataParams="{keyType:3,communicateProtocol:editFormData.communicateProtocol}" :funType="$t('BasicProduct.funcBox.sideList.side3')+' 0x03'" @addData="setData" @todelData="todelData"></TableTemp>
                </div>
                <div id="yellow" class="scroll-item" style="min-height:300px;background-color:whrite">
                    <h3 style="margin:15px 0;">{{$t('BasicProduct.funcBox.sideList.side4')}}  0x04</h3>
                    <TableTemp dataUrl="" :dataObj="resData" :dataParams="{keyType:4,communicateProtocol:editFormData.communicateProtocol}"  :isGener="true" :funType="$t('BasicProduct.funcBox.sideList.side4')+' 0x04'" @addData="setData" @todelData="todelData"></TableTemp>
                </div>
                <div id="pink" class="scroll-item" style="min-height:300px;background-color:whrite">
                    <h3 style="margin:15px 0;">{{$t('BasicProduct.funcBox.sideList.side5')}}  0x05</h3>
                    <TableTemp dataUrl="" :dataObj="resData" :dataParams="{keyType:5,communicateProtocol:editFormData.communicateProtocol}"  :isGener="true" :funType="$t('BasicProduct.funcBox.sideList.side5')+' 0x05'" @addData="setData" @todelData="todelData"></TableTemp>
                </div>

                <div id="pink1" class="scroll-item" style="min-height:300px;background-color:whrite">
                    <h3 style="margin:15px 0;">{{$t('BasicProduct.funcBox.sideList.side6')}}  0x06</h3>
                    <Button type="success" class="addButton" @click="addData(1,6,$t('BasicProduct.funcBox.sideList.side6')+' 0x06')" style="margin-right:8px;">{{$t("BasicProduct.funcBox.add")}}</Button>

                    <TableTemp dataUrl="" :dataObj="resData" :dataParams="{keyType:6,communicateProtocol:editFormData.communicateProtocol}"   :funType="$t('BasicProduct.funcBox.sideList.side6')+' 0x06'" @addData="setData" @todelData="todelData"></TableTemp>
                </div>

                <div id="pink2" class="scroll-item" style="min-height:300px;background-color:whrite">
                    <h3 style="margin:15px 0;">{{$t('BasicProduct.funcBox.sideList.side7')}}  0x07</h3>
                    <Button type="success" class="addButton" @click="addData(1,7,$t('BasicProduct.funcBox.sideList.side7')+' 0x07')" style="margin-right:8px;">{{$t("BasicProduct.funcBox.add")}}</Button>

                    <TableTemp dataUrl="" :dataObj="resData" :dataParams="{keyType:7,communicateProtocol:editFormData.communicateProtocol}"  :funType="$t('BasicProduct.funcBox.sideList.side7')+' 0x07'" @addData="setData" @todelData="todelData"></TableTemp>
                </div>


                <div id="black" class="scroll-item" style="min-height:300px;background-color:whrite">
                    <h3 style="margin:15px 0;">{{$t('BasicProduct.funcBox.sideList.side8')}}  0x08</h3>
                    <Button type="success" class="addButton" @click="addData(1,8,$t('BasicProduct.funcBox.sideList.side8')+' 0x08')" style="margin-right:8px;">{{$t("BasicProduct.funcBox.add")}}</Button>

                    <TableTemp dataUrl="" :dataObj="resData" :dataParams="{keyType:8,communicateProtocol:editFormData.communicateProtocol}" :funType="$t('BasicProduct.funcBox.sideList.side8')+' 0x08'" @addData="setData" @todelData="todelData"></TableTemp>
                </div>


                <div id="black1" class="scroll-item" style="min-height:300px;background-color:whrite">
                    <h3 style="margin:15px 0;">{{$t('BasicProduct.funcBox.sideList.topSide3')}}</h3>
                    <Button type="info" class="addButton" @click="importData(1,1,$t('BasicProduct.funcBox.sideList.side1')+' 0x01')" style="margin-right:8px;">{{$t("BasicProduct.funcBox.importedFunc")}}</Button>
                    <Button v-if="1" type="info" class="addButton" @click="importExcelData" style="margin-right:8px;">{{$t("BasicProduct.funcBox.importedExcel")}}</Button>
                    <Button v-if="1" type="primary" class="addButton" @click="savetoexcel" style="margin-right:8px;">{{$t("BasicProduct.funcBox.exportedExcel")}}</Button>
                </div>


            </div>
        </div>




        
        <!-- 新增、编辑 -->
        <ModelBox :showSetModel.sync="addBox.showSetModel" :published="editFormData.published || false"  :type="type" :basicTypeId='basicTypeId' :pageId="editFormData.pageId" :designImplTypeNum="addBox.designImplTypeNum" :isGener="addBox.isGener" :keyType="addBox.keyType" :funType='addBox.funType' :editFormData="addBox.editFormData" :fn="addBox.callbackFn"></ModelBox>
            
        <!-- 更新记录 -->
        <ModelLogBox :showSetModel.sync="LogBox.showSetModel"  :fn="LogBox.callbackFn"></ModelLogBox>

         <!-- 导入 -->
        <ImportBox :showSetModel.sync="importBox.showSetModel"  :designImplType="editFormData.designImplType" :basicTypeId="basicTypeId"  :fn="importBox.callbackFn"></ImportBox>
        
       <!-- 已发布，修改需要输入管理员密码 -->
       <AdminModel ref='verifyPwdRef' :showSetModel.sync="adminModelBox.showModel"  :editFormData="adminModelBox.editFormData" :fn="adminModelBox.callbackFn" :loading="adminModelBox.loading"></AdminModel>
      
       <!-- 导入Excel -->
      <ImportExcelBox :showModel.sync="importExcelBox.showSetModel" dataType="basci"   :basicTypeId="basicTypeId" :fn="importExcelBox.callbackFn"></ImportExcelBox>
           
    </div>

</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import { mapState,mapMutations } from 'vuex'
import TableTemp from "./table.vue"
import ModelBox from './setFuncModel.vue'
import ModelLogBox from './setLogModel.vue'
import ImportBox from './componentImport/importModel.vue'; // 引入导入弹框组件
import AdminModel from './componentOther/showAdminModel.vue';  
import ImportExcelBox from './componentImport/importExcelModel.vue'; // 引入导入弹框组件
import * as XLSX from 'xlsx/xlsx.mjs';


    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            editFormData:Object,
        },
        name: "ModelFunc",
        components: {
            TableTemp,
            ModelBox,
            ModelLogBox,
            ImportBox,
            AdminModel,
            ImportExcelBox
        },
        data() {
            return {   
                disabled: false,//禁用确定按钮
                type:1,
                addBox:{//规格弹框组-新增
                    showSetModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                    funType:'',
                    keyType:0,
                    isGener:false,//是否可以删除，通用的功能和参数新增后不能删除，加了isGener=true， 修改只能改默认值，，没加可以删除
                    designImplTypeNum:0
                },
                LogBox:{//规格弹框组-新增
                    showSetModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                },
                activeName:'1-1',
                formData: {//表单数据
                   
                },
                basicTypeId:null,
                scroll:'',
                resData:{
                    loading:true,
                    published:false,
                    pageId:'',
                    result:[]
                },
                pageID:'',
                wordList:[],
                importBox:{//规格弹框组-新增
                    showSetModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                },
                adminModelBox:{
                    showModel:false,
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                    loading:false
                },
                importExcelBox:{//规格弹框组-新增
                    showSetModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                },
               
            }
        },
        watch:{
            async showModel(val){
                if(val === true) {
                    this.pageID = this.editFormData.pageId || this.pageIdStore || ''

                    // console.log('this.editFormDataeditFormDataeditFormDataeditFormData',this.editFormData)

                    if(this.editFormData.id){
                        this.basicTypeId = this.editFormData.id
                        // this.addBox.designImplType = this.editFormData.designImplType   //原来，20220328之前
                        // this.addBox.designImplType = this.editFormData.communicateProtocol==1?2:1   //20220328之后，根据协议类型判断

                        this.addBox.designImplTypeNum = this.editFormData.communicateProtocol==1?2:1   //20231208 

                        this.resData.pageId = this.editFormData.pageId
                        this.resData.published = this.editFormData.published
                        // await this.getWordList()
                        await this.getData()
                    }
                //    console.log('this.basicClassIdArr',this.editFormData)
                   
                } else { //关闭弹框后要做的处理
                }
            },
             scroll() {
               this.loadSroll()
             }
        },
        computed:{
             ...mapState(['local','selectId','showLeftPx','pageIdStore']),
             title(){
                let title = this.$t('BasicProduct.funcBox.title')
                return title
             }
        },
       async created(){
          
        },
        mounted(){
            const scrollview  = this.$refs.contentRef
            if(scrollview){
                scrollview.addEventListener('scroll', this.scrollChange, true)
            }
 
        },
        beforeDestroy() {
            const scrollview = this.$refs.contentRef
            if(scrollview){
                scrollview.removeEventListener('scroll', this.scrollChange, true) 
            }
        },
        methods: {
            ...mapMutations(['setwordListByPageId','setWordList']),
            async  getWordList(){
                let params={
                        page:1,
                        limit:100000,
                        pageId:this.editFormData.pageId || this.pageID
                    }
                let  result = await this.axios.post(this.config.urlArray.pagesLangDictionaryList,params)
                if(result){
                    this.wordList = result.data.data.dealersList
                 
                    this.setwordListByPageId(this.wordList)
                    
                }
                
            },
            chooseMenu(e){//选择类型
                let aa = e.split('-')
                let idx = aa[aa.length-1]-1
                let items  = document.querySelectorAll(".scroll-item");
                for (var i = 0; i < items.length; i++) {
                    if (idx === i) {
                            // location.hash = item.name
                        items[i].scrollIntoView({
                          block: "start",//默认跳转到顶部
                          behavior: "smooth"//滚动的速度
                        });
                    }
                }

            },
            scrollChange(e){//滚动距离
                this.scroll = e.target.scrollTop

            },
            loadSroll(){//根据滚动距离，对应类型active
               let items  = document.querySelectorAll(".scroll-item");
               
               for (var i = 0; i < items.length; i++) {
                   let top = items[i].getBoundingClientRect().top-175
                   let height = items[i].getBoundingClientRect().height
                   if(top+height>0){
                        if(i+1>7){
                            this.activeName = '3'+'-'+(i+1)
                        }else if(i+1>5){
                            this.activeName = '2'+'-'+(i+1)
                        }else{
                            this.activeName = '1'+'-'+(i+1)
                        }
                       break
                   }
                }
            },
            importData(type,keyType,funType,row={}){//导入
                this.importBox.showSetModel = true
               
                this.importBox.callbackFn = (flag) => {//回调处理
                    //重新载入
                    this.importBox.showSetModel = false;
                   
                    if(flag){//刷新

                        this.getData();
                    }
                }
            },
            addData(type,keyType,funType,row={}){//新增
                this.addBox.showSetModel = true
                this.addBox.funType = funType
                this.addBox.keyType = keyType
                if(keyType==4 || keyType==5){
                    this.addBox.isGener = true
                }else{
                    this.addBox.isGener = false
                }
                
                this.type = type
                if(type == 2) {
                    this.addBox.editFormData = row
                }
                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.addBox.showSetModel = false;
                    this.addBox.funType = ''
                    this.addBox.keyType = 0
                    this.getData();
                }
            },
            addLogData(){
                this.LogBox.showSetModel = true
                this.LogBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.addBox.showSetModel = false;
                    this.getLogData();
                }

            },
            setData(data){//、编辑数据
                this.addData(2,data.keyType, data.funType,data.row)
                // console.log('row',row)
            },
            showAdminData(url,params) {  //发布后的基础型号修改需要输入管理员密码

                console.log('删除',params)
            
                this.adminModelBox.showModel = true
                this.adminModelBox.callbackFn = (password) => {//回调处理
                    //重新载入
                    this.adminModelBox.loading = true;
                    this.axios.post(url,{...params,password:password}).then(result=>{
                         common.ajaxMsg(result.data,true,()=>{
                            this.adminModelBox.loading = false;
                            this.$refs.verifyPwdRef.handleCancel()
                            this.getData();
                             
                         },()=>{
                            this.adminModelBox.loading = false;
                        })
                    }).catch((err) => {
                        this.adminModelBox.loading = false;
                    });
                }
            },
            todelData(data){//删除数据

                // if(data.published){
                //     this.showAdminData(this.config.urlArray.delBasicKeys,{id:data.id})
                //     return
                // }

                if(this.editFormData.majorKeyId && this.editFormData.majorKeyId==data.id){
                    common.msg("error", '主功能键不能删除');
                    return
                }

               this.axios.post(this.config.urlArray.delBasicKeys,{id:data.id}).then(result=>{
                    common.ajaxMsg(result.data,true,()=>{
                        this.getData();
                    },()=>{
                        if(result.data.code == 14053){//需要输入密码才能操作
                            this.showAdminData(this.config.urlArray.delBasicKeys,{id:data.id})
                        }
                    })
               })
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
                this.$emit('update:offModel',true);
            },
            resetForm() {//重置表单
                this.disabled = false;//恢复提交按钮为激活状态
            },
            async getData(){ //获取数据
                let params ={
                        basicTypeId:this.basicTypeId,
                        // serachMajorKey:false
                    }
                let  result = await this.axios.post(this.config.urlArray.getBasicKeys,params)
                if(result){
                    
                    this.resData.result = result.data.data
                    this.resData.result.map((item,index)=>{
                        // let res1 = {}
                        // try{
                        //    res1 = JSON.parse(item.keyName)
                        // } catch{}

                        // if(res1.hasOwnProperty('wordId') && this.wordList.length){
                        //     this.wordList.map(sitem=>{
                        //         if(sitem.id==res1.wordId){
                        //           res1['CN'] = sitem.simpleChinese
                        //           res1['EN'] = sitem.englishText
                        //         }
                        //     })
                        //    item.keyName = JSON.stringify(res1)

                        // }

                        // let sarr = null;
                        // try {
                        //     sarr = JSON.parse(item.formatContent)
                        // } catch (u) {}

                        // let sarrType = Object.prototype.toString.call(sarr)

                        // if(sarrType=='[object Array]' && this.wordList.length){
                        //     sarr.map(item=>{
                        //         this.wordList.map(sitem=>{
                        //             if(sitem.id==item.wordId){
                        //                 if(item.hasOwnProperty('Name-CN')){
                        //                     item['Name-CN'] = sitem.simpleChinese
                        //                     item['Name-EN'] = sitem.englishText
                        //                 }
                        //                 if(item.hasOwnProperty('Unit-CN')){
                        //                     item['Unit-CN'] = sitem.simpleChinese
                        //                     item['Unit-EN'] = sitem.englishText
                        //                 }

                        //             }
                        //             if(sitem.id==item['0x00 wordId']){
                        //                     item['0x00-CN'] = sitem.simpleChinese
                        //                     item['0x00-EN'] = sitem.englishText
                        //             }
                        //             if(sitem.id==item['0x01 wordId']){
                        //                     item['0x01-CN'] = sitem.simpleChinese
                        //                     item['0x01-EN'] = sitem.englishText
                        //             }
                        //             if(sitem.id==item['False wordId']){
                        //                     item['False-CN'] = sitem.simpleChinese
                        //                     item['False-EN'] = sitem.englishText
                        //             }
                        //             if(sitem.id==item['True wordId']){
                        //                     item['True-CN'] = sitem.simpleChinese
                        //                     item['True-EN'] = sitem.englishText
                        //             }
                        //         })
                                
                        //     })
                        //     item.formatContent = JSON.stringify(sarr)

                        // }
 
                        if(item.sortNumber!==0 && !item.sortNumber){
                          item.sortNumber = null
                        }
                        item.sortVal = index+1
                        return item
                    })





                    this.resData.loading = false
                }
            },
            async savetoexcel(){//导出
                 // 自定义下载的header，注意是数组中的数组哦
                 const Header = [["basicTypeId","chooseToUse","conUiCode","conditionJudgment","defaultValue","descr","formatContent","formatType","hexValueBytes","id","keyId","keyName","keyType","offlineOperation","propertyId","readWrite","remark","required","senseAction","senseCondition","sortNumber","taskUiCode","whetherMajor"]];
                
                 // 需要导出的数据
                const exportArr = []
                this.resData.result.map(item=>{
                    let obj = {} 
                    Header[0].forEach(key=>{obj[key]=item[key]})
                    exportArr.push(obj)
                })
              
            
                // 将JS数据数组转换为工作表。
                const headerWs = XLSX.utils.aoa_to_sheet(Header);
                const ws = XLSX.utils.sheet_add_json(headerWs, exportArr, {skipHeader: true, origin: 'A2'});
            
                /* 新建空的工作表 */
                const wb = XLSX.utils.book_new();
            
                // 可以自定义下载之后的sheetname
                XLSX.utils.book_append_sheet(wb, ws, 'sheetName');
                
            
                /* 生成xlsx文件 */
                XLSX.writeFile(wb,`basicTypeId${this.basicTypeId}.xlsx` );
            },
            importExcelData(){//导入excel,想达到的目的是，开发环境上编好后，生产环境可以直接导入
                this.importExcelBox.showSetModel = true
              
                this.importExcelBox.callbackFn = () => {
                    //重新载入
                    this.importExcelBox.showSetModel = false;
                    this.getData();
                }
            },
        }
    }
</script>

<style lang='less' scoped>
/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
.verAddCon{
    position: relative;
    .mainTitle{
        font-size: 20px;
        // position: fixed;
        // z-index: 99;
        background-color: #fff;
    }
    .colseButton{
        position: absolute;
        right: -18px;
        top:-18px
    }
    .content{
        margin-left: 240px;
        height: calc(100vh - 230px);
        // overflow-y: scroll;
        overflow: auto;
    }
}
 /deep/ .ivu-form-item-content{
      margin-left: 176px !important;
  }
.logoCon{
  /deep/ .ivu-form-item-content{
      margin-left: 0px !important;
  }
}
 /deep/ .ivu-form .ivu-form-item-label{
    width: 162px !important;
}


.side{
    position: fixed;
    left: 302px;
    top:175px;
    /deep/ .ivu-menu-vertical.ivu-menu-light:after {
      background: #fff;
   }
}


</style>
